import { useEffect, useState } from 'react';
import { GITHUB_REPOS_URL } from '../constants';

export const useProjectsData = () => {
  const [projects, setProjects] = useState([]);
  const [status, setStatus] = useState('loading');
  const [errorMessage, setErrorMessage] = useState('');

  useEffect(() => {
    const controller = new AbortController();

    const fetchProjects = async () => {
      setStatus('loading');
      setErrorMessage('');

      try {
        const response = await fetch(GITHUB_REPOS_URL, {
          signal: controller.signal,
          headers: {
            Accept: 'application/vnd.github+json',
          },
        });

        if (!response.ok) {
          throw new Error('GitHub API request failed.');
        }

        const data = await response.json();
        const mappedProjects = data.map((repo) => ({
          id: repo.id,
          name: repo.name,
          description: repo.description || 'No description provided yet.',
          repoUrl: repo.html_url,
          liveUrl: repo.homepage || null,
          tags: repo.language ? [repo.language] : [],
          language: repo.language,
          stars: repo.stargazers_count,
          updatedAt: repo.pushed_at,
          createdAt: repo.created_at,
        }));

        setProjects(mappedProjects);
        setStatus('success');
      } catch (error) {
        if (error.name === 'AbortError') {
          return;
        }

        setErrorMessage('Unable to load projects right now. Please try again later.');
        setStatus('error');
      }
    };

    fetchProjects();

    return () => controller.abort();
  }, []);

  return {
    projects,
    status,
    errorMessage,
  };
};
